import React, { useState,useEffect } from 'react';
import {
    Input,Button,Layout,
    Row,Col,
    Form,
    Steps,
    Card,Collapse,
    Checkbox,
    Table
} from 'antd';
import {EnvironmentOutlined} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    GetTemplateDetailToView
} from '@/util/Request';
import moment from 'moment';
const { Content } = Layout;
const { Step } = Steps;
const { Meta } = Card;
const { Panel } = Collapse;
import TemplateViewGoogleMap from '@/components/TemplateViewGoogleMap';
import './index.less';
import { useNavigate,useLocation } from 'react-router-dom';
function Collapsecallback(key){
    console.log(key);
}
const ViewTemplate = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [stepsKey,setStepsKey] = useState<number>(0);
    const [mark,setMark] = useState([] as any);
    const [selectIds,setSelectIds] = useState([] as any);
    const [update,setUpdate] = useState(false);
    const [defaultCenter,setDefaultCenter] = useState(null);
    const [ajaxLayer,setAjaxLayer] = useState([]);
    const [layerMap,setLayerMap] = useState(new Map());
    const [layerMapSelectId,setLayerMapSelectId] = useState(new Map());
    const [ajaxData,setAjaxData] = useState({
        propertiesList:[],
        infoList:[],
        profilesList:[]
    });
    const [layer,setLayer] = useState([]);
    useEffect(() => {
        GetAnalyses();
    }, []);
    const GetAnalyses = async ()=>{
        const res = await GetTemplateDetailToView(location.state);
        // const res = {
        //     infoList: [{
        //         "action_Name": "TemplateName",
        //         "action_By": "test222"
        //     },
        //     {
        //         "action_Name": "SampleRequestedBy",
        //         "action_By": "t957122"
        //     },
        //     {
        //         "action_Name": "SamplaingDate",
        //         "action_By": "2022-07-06"
        //     },
        //     {
        //         "action_Name": "SampleTakenBy",
        //         "action_By": "t957122"
        //     },
        //     {
        //         "action_Name": "SampleAnalyzedBy",
        //         "action_By": "t957122"
        //     }],
        //     profilesList: [{
        //         "layerId": 211,
        //         "layerRank": "Top Layer - 1",
        //         "thickNess": "20",
        //         "profileId": "133",
        //         "profileCode": "PROF000000103",
        //         "profileLongitude": 54.95667,
        //         "profileLatitude": 55.00167,
        //         "profileName": "Test Delete Layer",
        //         "profilePlaceName": "Russia",
        //         "profileFityName": "Greenhouse",
        //         "profileStatus": "Draft"
        //     },
        //     {
        //         "layerId": 231,
        //         "layerRank": "123 - 1",
        //         "thickNess": "123",
        //         "profileId": "144",
        //         "profileCode": "PROF000000114",
        //         "profileLongitude": 71.19923,
        //         "profileLatitude": 31.25551,
        //         "profileName": "123",
        //         "profilePlaceName": "Pakistan",
        //         "profileFityName": "Greenhouse",
        //         "profileStatus": "Draft"
        //     }],
        //     propertiesList: [{
        //         "propId": 8,
        //         "category": "Physical",
        //         "propName": "Clay",
        //         "propMeasureId": 10,
        //         "methodName": "Measurement - Sedimentation : % weight",
        //         "unitName": "% weight"
        //     }]
        // };
        const arr_map = (arr,id) => {
            const res = new Map();
            return arr.filter((a) => !res.has(a[id]) && res.set(a[id], 1));
        };
        res.infoList.map(obj=>{
            if(obj.action_Name == 'SamplaingDate'){
                form.setFieldsValue({ [obj.action_Name]: moment(obj.action_By).format('DD-MM-YYYY') });
            }else{
                form.setFieldsValue({ [obj.action_Name]: obj.action_By });
            }
        });
        const mar = arr_map(res.profilesList,'profileId');
        await setMark(mar);
        mar.map(obj=>{
            // layerMap,setLayerMap
            layerMap.set(obj.profileId,[]);
            setLayerMap(layerMap);
        });
        res.profilesList.forEach(obj=>{
            const axc = layerMap.get(obj.profileId);
            if(axc.filter(ob=>ob.layerId==obj.layerId).length==0){
                axc.push(obj);
            }
            layerMap.set(obj.profileId,axc);
            setLayerMap(layerMap);
        });
        await setAjaxLayer(res.profilesList);
        setAjaxData(res);
        setDefaultCenter({
            lat:res.profilesList[0].profileLatitude,
            lng:res.profilesList[0].profileLongitude
        });
        setUpdate(!update);
    };
    const addStep = ()=>{
        setStepsKey(stepsKey+1);
    };
    const resStep = ()=>{
        setStepsKey(stepsKey-1);
    };
    const addMarksCallBack = async (param)=>{
        console.log([...ajaxData.profilesList.filter(e=>param.profileId==e.profileId)]);
        setLayer([...ajaxData.profilesList.filter(e=>param.profileId==e.profileId)]);
        setUpdate(!update);
        console.log(param);
    };
    const lngClick = (lng:any)=>{
        console.log(lng);
        setDefaultCenter({
            lat:lng.profileLatitude,
            lng:lng.profileLongitude
        });
        setUpdate(!update);
    };
    const lngDelete = (lng:any)=>{
        console.log(lng);
    };

    const columns2 = [
        {
            title: ()=>(<h4 className="soliHeader" style={{fontSize:'14px'}}>{'Soil Properties'}</h4>),
            dataIndex: 'propId',
            width:'33%',
            render: (text, record, index) => (
                <div className='default-table-height'>
                    {/* <Tag color="success">{record.propertyClass}</Tag> */}
                    <span style={{
                        background: record.category=='Physical'?'#C6E6FF':'#E7DDFC',
                        color: record.category=='Physical'?'#005693':'#643AAA',
                        padding:'3px 5px',borderRadius:'3px',margin:'0 10px',fontSize:'12px',fontWeight:600,lineHeight:'16px'
                    }}>{record.category}</span>
                    <span>{record.propName}</span>
                </div>
            )
        },
        {
            title: ()=>(<h4 className="soliHeader" style={{fontSize:'14px'}}>{'Unit'}</h4>),
            width:'33%',
            dataIndex: 'unitName',
        },
        {
            title: ()=>(<h4 className="soliHeader" style={{fontSize:'14px'}}>{'Estimation Method'}</h4>),
            width:'33%',
            dataIndex: 'methodName',
        },
    ];
    const cannel = ()=>{
        navigate('/templateUpdate',{});
    };
    return (
        <div className="soil-template-container-style newTemplate" style={{padding:10}}>
            <Content style={{ backgroundColor: '#fff' }}>
                <Row gutter={20}>
                    <Col span={8}>
                        <h2 className="soliHeader" style={{paddingLeft:0,marginBottom:16}}>View Template</h2>
                        {stepsKey==0&&<h4 className="soliHeader" style={{paddingLeft:0,fontSize:'16px',marginBottom:19}}>Soil Profile</h4>}
                        {stepsKey==1&&<h4 className="soliHeader" style={{paddingLeft:0,fontSize:'16px',marginBottom:19}}>Soil properties</h4>}

                        {
                            stepsKey==0&&<div>
                                {/* <h5>Input profile name, ID or location</h5> */}
                                <h4 style={{fontSize:12,fontWeight:600,margin:'0 0 16px 0'}}>MY SOIL PROFILE </h4>
                                {
                                    mark.length>0&&<div style={{height:'calc(100vh - 230px)',overflow:'auto'}}>
                                        {
                                            mark.map(obj=>{
                                                console.log(obj);
                                                return (
                                                    // <>
                                                    <Card
                                                        key={obj.id}
                                                        size="small"
                                                        style={{position:'relative',marginBottom:10}}
                                                    >
                                                        <Meta style={{}}
                                                            description={obj.profileCode }
                                                            title= {obj.profileName}
                                                        />
                                                        <div style={{position:'absolute',right:10,top:15,display:'flex'}}>
                                                            <EnvironmentOutlined onClick={e=>lngClick(obj)} style={{marginTop:2}}/>
                                                        </div>
                                                        <Collapse
                                                            defaultActiveKey={['1']}
                                                            onChange={Collapsecallback}
                                                            expandIconPosition={'end'}
                                                            collapsible='header'
                                                        >
                                                            <Panel
                                                                header={'Soil Layers'}
                                                                key='added-by-navi-2022-09-09'
                                                                extra={
                                                                    <Checkbox
                                                                        checked={true}
                                                                    ></Checkbox>
                                                                }>
                                                                <div>
                                                                    {
                                                                        layerMap.get(obj.profileId).length>0&&layerMap.get(obj.profileId).map((ob,ix)=>{
                                                                            return (
                                                                                // <Row key={ob.layerId} style={{padding:'9px 0'}}>
                                                                                //     <Col span={21}>{ob.layerRank} | {ob.thickNess} cm</Col>
                                                                                //     <Col span={3} style={{textAlign:'right'}}>
                                                                                //         <Checkbox checked={true} disabled
                                                                                //         ></Checkbox>
                                                                                //     </Col>
                                                                                // </Row>
                                                                                <Row key={ob.layerId} className='fathers' style={{height:ix==0?'25px':'40px'}}>
                                                                                    <Col span={21} style={{top:ix==0?'12px':'27px'}} className='sun1'>
                                                                                        {ob.layerRank} | {ob.thickNess.replace(/,/g,'-')} cm
                                                                                    </Col>
                                                                                    <Col span={3} style={{top:ix==0?'12px':'27px',textAlign:'right'}} className='sun2'>
                                                                                        <Checkbox checked={true} ></Checkbox>
                                                                                    </Col>
                                                                                </Row>
                                                                            );
                                                                        })
                                                                    }
                                                                </div>
                                                            </Panel>
                                                        </Collapse>
                                                    </Card>
                                                    // </>
                                                );
                                            })
                                        }
                                        {
                                            stepsKey==0&&<footer className='bottomBottons' style={{padding:'20px'}}>
                                                <Button type="text" shape="round" >
                                                    <Link to="/templateUpdate">Cancel</Link>
                                                </Button>
                                                <Button type="primary" shape="round" onClick={addStep}>Next</Button>
                                            </footer>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {/* {
                            stepsKey==0&&<footer className='bottomBottons' style={{padding:'20px'}}>
                                <Button type="text" shape="round" >
                                    <Link to="/templateUpdate">Cancel</Link>
                                </Button>
                                <Button type="primary" shape="round" onClick={addStep}>Next</Button>
                            </footer>
                        } */}
                        {
                            stepsKey==2&&<div>
                                {/* <h4 className="soliHeader">Finish</h4> */}
                                <h4 className="soliHeader" style={{fontSize:'16px',marginBottom:'20px',padding:0}}>Finish</h4>
                                <Form name="nest-messages" layout="vertical" form={form}>
                                    <Form.Item name="TemplateName" label="Template Name" rules={[{ required: true }]}>
                                        <Input placeholder='e.g. Spain fields' disabled/>
                                    </Form.Item>
                                    <Form.Item label="Sample Requested by" name="SampleRequestedBy" rules={[{ required: true }]}>
                                        <Input placeholder='Altman Mike USGR' disabled/>
                                    </Form.Item>
                                    <Form.Item label="Sampling Date" name="SamplaingDate" rules={[{ required: true }]}>
                                        <Input placeholder='Select date' disabled/>
                                    </Form.Item>
                                    <Form.Item label="Sample Taken by" name="SampleTakenBy">
                                        <Input placeholder='Select' disabled/>
                                    </Form.Item>
                                    <Form.Item label="Sample Analyzed by" name="SampleAnalyzedBy">
                                        <Input placeholder='Galys Laboratoire' disabled/>
                                    </Form.Item>
                                </Form>
                                <footer className='bottomBottons'>
                                    <Button
                                        type="text" shape="round" onClick={resStep}>Back</Button>
                                    <Button
                                        type="primary"
                                        shape="round" onClick={cannel}>Cannel</Button>
                                </footer>
                            </div>
                        }
                    </Col>
                    <Col span={16} style={{padding:'0 20px'}}>
                        <Col span={24} style={{paddingBottom:'10px'}}>
                            <div className="soliHeader">
                                <Steps size="small" current={stepsKey}>
                                    <Step title="Soil Profile" />
                                    <Step title="Soil Properties" />
                                    <Step title="Finish" />
                                </Steps>
                            </div>
                        </Col>
                        <Col span={24}>
                            {stepsKey!=1&&<TemplateViewGoogleMap marks={mark} selectId={selectIds} isNew={update} defaultCenter={defaultCenter} layer={layer} markerClick={addMarksCallBack}/>}
                        </Col>
                    </Col>
                    <Col span={24} style={{display:stepsKey==1?'block':'none'}}>
                        <Content style={{ backgroundColor: '#fff' }}>
                            <Table
                                className='NoRadius'
                                rowKey={record => record.id}
                                columns={columns2}
                                dataSource={ajaxData.propertiesList}
                                pagination={false}
                            />
                        </Content>
                        {/* <NextModel saveTable={submitTableData} Table={undefined} editOption={nextOption} visible={updataKey} editParam={null} disabled={false}/> */}
                    </Col>
                </Row>

            </Content>
            {
                stepsKey==1&&<div className='bottomBotton2'>
                    <Button type="text" shape="round" onClick={resStep}>Back</Button>
                    <Button type="primary" shape="round" onClick={addStep}>Next</Button>
                </div>
            }
        </div>
    );
};
export default ViewTemplate;